import { css } from 'emotion';

export default {
    container: css`
        margin-bottom: 10px;
        display: flex;
        flex-direction: column;
    `,
    contentContainer: css`
        display: flex;
        margin-bottom: 5px;
    `,
    dispatchType: css`
        margin-right: 3px;
    `,
    iconContainer: css`
        margin-left: 4px;
    `,
    auditText: css`
        display: flex;
        flex-direction: row;
        align-items: center;
        font-weight: 300;
    `
};
